<template>
  <div class="pod-list">
    <data-table
      :headers="headers"
      v-model="pods"
      :items-per-page="10"
      filterable
      editable-columns
      title="Pods"
    >
      <template v-slot:item.actions="{ item }">
        <loading-icon-button
          @click="openPod(item)"
          tooltip="Edit Pod"
          :loading="progress_indicator.edit_user_pod_id == item.id"
        >
          edit
        </loading-icon-button>
        <loading-icon-button
          v-if="checkIfNotParent(item)"
          @click="editAvailableLenders(item)"
          tooltip="Edit Available Lenders"
          :loading="progress_indicator.edit_user_pod_id == item.id"
        >
          account_balance
        </loading-icon-button>
        <loading-icon-button
          @click="deletePod(item)"
          tooltip="Delete Pod"
          :loading="progress_indicator.remove_user_pod_id == item.id"
        >
          clear
        </loading-icon-button>
      </template>
    </data-table>
  </div>
</template>
<script>
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";
import filters from "@/components/utils/filters";

export default {
  components: {
    LoadingIconButton,
    DataTable,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: null,
      default: () => null,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'ID',
          value: 'id',
          sort: true,
          width: '105px',
          search: true,
        },
        {
          text: "Pod Code",
          value: "pod_code",
          sort: false,
          search: true,
        },
        {
          text: "Name",
          value: "name",
          sort: false,
          search: true,
        },
        {
          text: "Description",
          value: "description",
          sort: true,
          search: true,
        },
        {
          text: "Parent",
          valueFunction: "parent",
          sort: false,
          search: true,
          valueFunction(item) {
            return (item.parent && item.parent.name) || "No Parent"; // Handle missing name
          },
        },
        {
          text: "User Count",
          value: "user_count",
          sort: true,
          search: true,
        },
        {
          text: "Status",
          value: "pod_status",
          sort: true,
          search: true,
        },
        {
          text: "Actions",
          value: "actions",
          align: "right",
          width: '150px',
          optional: false,
        },
      ],
      progress_indicator:{
        edit_user_pod_id: false,
        remove_user_pod_id: false,
      }
    }
  },
  methods: {
    openPod(pod){
      this.$emit("open-pod", pod);
    },
    deletePod(pod) {
      this.$emit("delete-pod", pod);
    },
    editAvailableLenders(pod) {
      this.$emit("edit-lenders", pod);
    },
    checkIfNotParent(pod) {
        return pod.parent_id == null;
    },
    ...filters,
  },
  computed: {
    pods() {
      return this.items ?? [];
    },
  },
  filters: {
    ...filters,
  },
  created() {

  },
}
</script>
<style scoped lang="scss">
::v-deep .red_role{
  border-left: solid 5px #d9808c;
}
</style>
